import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { RoutingQueryParams } from '../interfaces';


@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  constructor(public router: Router) {}

  getParamsLazy(param: string): number {
    const url = this.router.url.split('?')[0];
    const splittedUrl = url.split('/');
    const indexOfParams = splittedUrl.indexOf(param);
    if (indexOfParams > -1) {
      return +splittedUrl[indexOfParams + 1];
    } else {
      return null;
    }
  }

  getParamsLazyString(param: string): string {
    const url = this.router.url.split('?')[0];
    const splittedUrl = url.split('/');
    const indexOfParams = splittedUrl.indexOf(param);
    if (indexOfParams > -1) {
      return splittedUrl[indexOfParams + 1];
    } else {
      return null;
    }
  }

  navigateBack(activatedRouteSnapShot?: ActivatedRouteSnapshot): void {
    const url = this.router.url.split('?')[0].split('/');
    if (activatedRouteSnapShot && activatedRouteSnapShot.params) {
      url.splice(url.length - 2, 2);
    } else {
      url.splice(url.length - 1, 1);
    }

    const backUrl = url.join('/');
    this.router.navigate([backUrl]);
  }

  navigateToSpecificPath(noOfRemovedPaths: number, specificPath: string , queryParams?:object) {
    const url = this.router.url.split('?')[0].split('/');
    url.splice(url.length - noOfRemovedPaths, noOfRemovedPaths);
    const navigationPath = url.join('/');
    this.router.navigate([navigationPath + '/' + specificPath] , {queryParams:queryParams});
  }

  // TODO:- Search for a good solution
  getRoutingParamsFromParent(activatedRouteSnapShot: ActivatedRouteSnapshot, param: string): string | null {
    var params = activatedRouteSnapShot['parent'];
    if(params){
      if (params['params'][param]) {
        return params['params'][param];
      } else {
        return this.getRoutingParamsFromParent(params, param);
      }
    }else {
      return null
    }

  }

  getQueryParamsFromUrl(activatedRoute: ActivatedRoute, paramsArray: string[]): string[] {
    let paramsValues: string[] = [];
    activatedRoute.queryParams.subscribe(params => {
      if (params) {
        paramsArray.forEach(paramElement => {
          if (params[paramElement]) {
            paramsValues.push(params[paramElement]);
          } else {
            paramsValues.push(null);
          }
        });
      }
    });
    return paramsValues;
  }

  setQueryParamsInUrl(queries: RoutingQueryParams[]) {
    let queryParams : object = {};
    queries.forEach(query => {
      queryParams[query.key] = query.value;
    });
    const url = this.router.url.split('?')[0];
    return this.router.navigate([url], {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }

  removeQueryParamsInUrl(): string {
    let url: string = this.router.url.split('?')[0];
    return url;
  }

  determineActiveRoute(activatedRouteSnapShot?: ActivatedRouteSnapshot): string {
    const url = this.router.url.split('?')[0].split('/');
    let activeRoute;
    if (activatedRouteSnapShot) {
      activeRoute = url.splice(url.length - 2, 1);
    } else {
      activeRoute = url.pop();
    }
    return activeRoute;
  }

  removeQueryParamsFromUrl() {
    const url = this.router.url.split('?')[0];
     return this.router.navigate([url]);
  }
}
